export const DISCOVER_PRIORITY = {
  HIGH: 1,
  MEDIUM: 2,
  LOW: 3,
};

export const DISCOVER_PRIORITY_OPTIONS = [
  { value: 1, label: "High" },
  { value: 2, label: "Medium" },
  { value: 3, label: "Low" },
];

export function getDiscoverPriorityLabel(value) {
  if (value === 1 || value === "1") return "High";
  if (value === 2 || value === "2") return "Medium";
  if (value === 3 || value === "3") return "Low";
  return "None";
}

export function getDiscoverPriorityBadgeClass(value) {
  if (value === 1 || value === "1") return "badge-danger";
  if (value === 2 || value === "2") return "badge-warning";
  if (value === 3 || value === "3") return "badge-info";
  return "badge-secondary";
}
